import { apiRequest, getApiUrl, haySesionActiva } from '../../config/api';

// Cliente de /api/whatsapp/campaigns. Ninguna función lanza: devuelven
// { ok, status, data } y, si la red falla, un 0 con un detail legible.

const BASE = '/whatsapp/campaigns';
const SIN_RED = { ok: false, status: 0, data: { detail: 'Error de conexión con el servidor.' } };
const SIN_SESION = { ok: false, status: 401, data: { detail: 'La sesión ha caducado. Vuelve a entrar.' } };

const leer = async (res) => ({
  ok: res.ok,
  status: res.status,
  data: await res.json().catch(() => ({})),
});

const json = async (ruta, opciones) => {
  try {
    return await leer(await apiRequest(getApiUrl(`${BASE}${ruta}`), opciones));
  } catch (e) {
    return SIN_RED;
  }
};

// Sin Content-Type: el navegador pone el boundary del multipart. La cabecera
// X-Requested-With la exige el filtro CSRF del backend. La autenticación va por
// la cookie httpOnly (credentials: 'include'), no por un header Authorization.
const cabeceras = (clave) => ({
  'X-Requested-With': 'XMLHttpRequest',
  ...(clave ? { 'Idempotency-Key': clave } : {}),
});

const multipart = async (ruta, method, cuerpo, clave) => {
  if (!haySesionActiva()) return SIN_SESION;
  try {
    return await leer(await fetch(getApiUrl(`${BASE}${ruta}`), {
      method,
      headers: cabeceras(clave),
      credentials: 'include',
      body: cuerpo,
    }));
  } catch (e) {
    return SIN_RED;
  }
};

const TAMANO_LISTADO = 50;
const TAMANO_DESTINATARIOS = 100;

export const listarCampanas = (botId, page = 0) =>
  json(`?botId=${botId}&page=${page}&size=${TAMANO_LISTADO}`);

export const detalleCampana = (id) => json(`/${id}`);

export const destinatariosCampana = (id, estado, page = 0) => {
  const filtro = estado ? `&estado=${encodeURIComponent(estado)}` : '';
  return json(`/${id}/recipients?page=${page}&size=${TAMANO_DESTINATARIOS}${filtro}`);
};

export const cancelarCampana = (id) => json(`/${id}/cancel`, { method: 'POST' });

export const analizarCampana = (cuerpo) => multipart('/analyze', 'POST', cuerpo);

export const crearCampana = (cuerpo, clave) => multipart('', 'POST', cuerpo, clave);

export const editarCampana = (id, cuerpo, clave) => multipart(`/${id}`, 'PUT', cuerpo, clave);

export const descargarPlantillaExcel = async (botId, templateName, languageCode) => {
  if (!haySesionActiva()) return false;
  try {
    const res = await fetch(getApiUrl(`${BASE}/template-file?botId=${botId}`
      + `&templateName=${encodeURIComponent(templateName)}&languageCode=${encodeURIComponent(languageCode)}`), {
      headers: cabeceras(),
      credentials: 'include',
    });
    if (!res.ok) return false;
    const url = URL.createObjectURL(await res.blob());
    const enlace = document.createElement('a');
    enlace.href = url;
    enlace.download = `${templateName}.xlsx`;
    enlace.click();
    // Revocar en el mismo turno que click() cancela la descarga antes de que arranque.
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return true;
  } catch (e) {
    return false;
  }
};
